import { ROLES_FETCHED } from "../commonActions/roles";

export default (state = null, action = {}) => {
  switch (action.type) {
    case ROLES_FETCHED:
      return action.payload;
    default:
      return state;
  }
};
